
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movie/[id]",
      function () {
        return require("private-next-pages/movie/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/movie/[id]"])
      });
    }
  